import { render, staticRenderFns } from "./RgPortfolioBanner.vue?vue&type=template&id=6abc97de&scoped=true&"
import script from "./RgPortfolioBanner.vue?vue&type=script&lang=js&"
export * from "./RgPortfolioBanner.vue?vue&type=script&lang=js&"
import style0 from "./RgPortfolioBanner.vue?vue&type=style&index=0&id=6abc97de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc97de",
  null
  
)

export default component.exports